export class PublicationPreference {
    public publicationName: string;
    public setting: string;

    public static fromJson = (data: any): PublicationPreference => {
        const dto = new PublicationPreference();
        dto.publicationName = data.publicationName;
        dto.setting = data.setting;
        return dto;
    }
}